import Request from './request';
import ServiceResultFactory from './ServiceResultFactory';

const showPlanUrl = (baseUrl, eventEditionId, showPlanningId) => `${baseUrl}/v1/event-editions/${eventEditionId}/show-plan/${showPlanningId}`;

const getShowPlan = (baseUrl, eventEditionId, showPlanningId) => {
  const baseApiUrl = baseUrl.endsWith('/')
    ? baseUrl.substring(0, baseUrl.length - 1)
    : baseUrl;

  const url = showPlanUrl(baseApiUrl, eventEditionId, showPlanningId);

  return Request.get(url)
    .then((response) => ServiceResultFactory.fromSuccess({ showPlan: response.body }))
    .catch((result) => {
      if (result.status === 404) {
        return { showPlan: { participationIds: [] } };
      }
      return ServiceResultFactory.fromError(result);
    });
};

export default { getShowPlan };
